export default __webpack_public_path__ + "static/media/kitchen5-afterD-768w.c7b869b9.webp";